export const readParquetObjectsFromUrl = async (url, options = {}) => {
  const { asyncBufferFromUrl, parquetReadObjects } = await import('hyparquet');
  const file = await asyncBufferFromUrl({ url, requestInit: options.requestInit, byteLength: options.byteLength });
  return parquetReadObjects({ file });
};
